function returnMarkupCA({
  Name,
  LocationType,
  Address,
  County
}) {


function formatLocType(LocationType){
  var resultstring
  if(LocationType!==""){
    resultstring=LocationType
  }
  else{
    resultstring="N/A"
  }
  return resultstring
}


const markup = `
    ${`<h3>${Name}</h3>`}
    ${`<p class="address">${Address}</p>`}
    ${`<p><span><b>Provider type</b></span>: ${formatLocType(LocationType)}</p>`}
    ${`<p><span><b>County</b></span>: ${County}</p>`}
    `
  return markup
}

export { returnMarkupCA }